import api from 'api';

export const Types = {
  GET_PERMISSOES: 'estados/GET_PERMISSOES',
  GET_PERMISSOES_SUCCESS: 'estados/GET_PERMISSOES_SUCCESS',
  GET_PERMISSOES_FAILED: 'estados/GET_PERMISSOES_FAILED',
  UPDATE_PERMISSOES: 'estados/UPDATE_PERMISSOES',
  UPDATE_PERMISSOES_SUCCESS: 'estados/UPDATE_PERMISSOES_SUCCESS',
  UPDATE_PERMISSOES_FAILED: 'estados/UPDATE_PERMISSOES_FAILED',
};

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export default function estadosReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PERMISSOES:
      return { ...state, loading: true };
    case Types.GET_PERMISSOES_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.GET_PERMISSOES_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.UPDATE_PERMISSOES:
      return { ...state, loading: true, error: undefined };
    case Types.UPDATE_PERMISSOES_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.UPDATE_PERMISSOES_SUCCESS:
      return { ...state };
    default:
      return state;
  }
}

export const Creators = {
  getPermissoes: () => async dispatch => {
    try {
      dispatch({ type: Types.GET_PERMISSOES });
      const permissoes = await api.get('/permissions');
      dispatch({
        type: Types.GET_PERMISSOES_SUCCESS,
        payload: { data: permissoes.data },
      });
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.GET_PERMISSOES_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
  updatePermissoes: () => async dispatch => {
    dispatch({
      type: Types.UPDATE_PERMISSOES,
    });
    try {
      await api.put('/update-permissions');
      dispatch({
        type: Types.UPDATE_PERMISSOES_SUCCESS,
      });
      dispatch(Creators.getPermissoes());
    } catch (eff) {
      dispatch({
        type: Types.UPDATE_PERMISSOES_FAILED,
        payload: { error: eff.message },
      });
    }
  },
};
